import { Routes } from '@angular/router';
import { autenticatedGuard } from './core/guards/autenticated.guard';
import { errorGuard } from './core/guards/error.guard';
import { rechazoGuard } from './core/guards/rechazo.guard';

export const routes: Routes = [
  {
    path: 'error',
    canActivate: [errorGuard],
    loadComponent: () =>
      import('./feature/error/error.component').then(m => m.ErrorComponent),
  },
  {
    path: 'home',
    canActivate: [autenticatedGuard],
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        m => m.MainLayoutComponent
      ),
    children: [
      {
        path: 'tu-nombre',
        loadComponent: () =>
          import('./feature/nombre/nombre.component').then(
            m => m.NombreComponent
          ),
      },
      {
        path: 'fecha-nacimiento',
        loadComponent: () =>
          import('./feature/fecha-nacimiento/fecha-nacimiento.component').then(
            m => m.FechaNacimientoComponent
          ),
      },
      {
        path: 'donde-naciste',
        loadComponent: () =>
          import('./feature/donde-naciste/donde-naciste.component').then(
            m => m.DondeNacisteComponent
          ),
      },
      {
        path: 'genero',
        loadComponent: () =>
          import('./feature/genero/genero.component').then(
            m => m.GeneroComponent
          ),
      },
      {
        path: 'curp',
        loadComponent: () =>
          import('./feature/curp/curp.component').then(m => m.CurpComponent),
      },
      {
        path: 'genero-edo-civil',
        loadComponent: () =>
          import('./feature/genero/genero.component').then(
            m => m.GeneroComponent
          ),
      },
      {
        path: 'tu-direccion',
        loadComponent: () =>
          import('./feature/direccion/direccion.component').then(
            m => m.DireccionComponent
          ),
      },
      {
        path: 'tu-calle',
        loadComponent: () =>
          import('./feature/calle/calle.component').then(m => m.CalleComponent),
      },
      {
        path: 'sobre-ti',
        loadComponent: () =>
          import('./feature/sobreti/sobreti.component').then(
            m => m.SobretiComponent
          ),
      },
      {
        path: 'ingreso-mensual',
        loadComponent: () =>
          import('./feature/ingreso-mensual/ingreso-mensual.component').then(
            m => m.IngresoMensualComponent
          ),
      },
      {
        path: 'origen-ingresos',
        loadComponent: () =>
          import('./feature/origen-ingresos/origen-ingresos.component').then(
            m => m.OrigenIngresosComponent
          ),
      },
      {
        path: 'celular',
        loadComponent: () =>
          import('./feature/celular/celular.component').then(
            m => m.CelularComponent
          ),
      },
      {
        path: 'capturar-codigo-celular',
        loadComponent: () =>
          import('./feature/codigo-celular/codigo-celular.component').then(
            m => m.CodigoCelularComponent
          ),
      },
      {
        path: 'referencias',
        loadComponent: () =>
          import('./feature/referencias/referencias.component').then(
            m => m.ReferenciasComponent
          ),
      },
      {
        path: 'autorizaciones',
        loadComponent: () =>
          import('./feature/autorizaciones/autorizaciones.component').then(
            m => m.AutorizacionesComponent
          ),
      },
      {
        path: 'creditos',
        loadComponent: () =>
          import('./feature/creditos/creditos.component').then(
            m => m.CreditosComponent
          ),
      },
      {
        path: 'eleccion-producto',
        loadComponent: () =>
          import(
            './feature/eleccion-producto/eleccion-producto.component'
          ).then(m => m.EleccionProductoComponent),
      },
      {
        path: 'resumen-sol-corta',
        loadComponent: () =>
          import(
            './feature/resumen-sol-corta/resumen-sol-corta.component'
          ).then(m => m.ResumenSolCortaComponent),
      },
      {
        path: 'preparate',
        loadComponent: () =>
          import('./feature/preparate/preparate.component').then(
            m => m.PreparateComponent
          ),
      },
      {
        path: 'identificacion-mexicano',
        loadComponent: () =>
          import(
            './feature/identificacion-mexicano/identificacion-mexicano.component'
          ).then(m => m.IdentificacionMexicanoComponent),
      },
      {
        path: 'identificacion-extranjero',
        loadComponent: () =>
          import(
            './feature/identificacion-extranjero/identificacion-extranjero.component'
          ).then(m => m.IdentificacionExtranjeroComponent),
      },
      {
        path: 'lista-espera',
        loadComponent: () =>
          import('./feature/lista-espera/lista-espera.component').then(
            m => m.ListaEsperaComponent
          ),
      },
      {
        path: 'ine-frontal',
        loadComponent: () =>
          import('./feature/ine-frontal/ine-frontal.component').then(
            m => m.IneFrontalComponent
          ),
      },
      {
        path: 'ine-reverso',
        loadComponent: () =>
          import('./feature/ine-reverso/ine-reverso.component').then(
            m => m.IneReversoComponent
          ),
      },

      {
        path: 'pasaporte',
        loadComponent: () =>
          import('./feature/pasaporte/pasaporte.component').then(
            m => m.PasaporteComponent
          ),
      },
      {
        path: 'pasaporte-frente-extranjero',
        loadComponent: () =>
          import('./feature/pasaporte/pasaporte.component').then(
            m => m.PasaporteComponent
          ),
      },
      {
        path: 'pasaporte-frente',
        loadComponent: () =>
          import('./feature/pasaporte/pasaporte.component').then(
            m => m.PasaporteComponent
          ),
      },
      {
        path: 'pasaporte',
        loadComponent: () =>
          import('./feature/pasaporte/pasaporte.component').then(
            m => m.PasaporteComponent
          ),
      },
      {
        path: 'pasaporte-extranjero',
        loadComponent: () =>
          import('./feature/pasaporte/pasaporte.component').then(
            m => m.PasaporteComponent
          ),
      },
      {
        path: 'selfie',
        loadComponent: () =>
          import('./feature/selfie/selfie.component').then(
            m => m.SelfieComponent
          ),
      },
      {
        path: 'fm2-fm3',
        loadComponent: () =>
          import('./feature/fm/fm.component').then(m => m.FmComponent),
      },
      {
        path: 'resumen-redicta',
        loadComponent: () =>
          import('./feature/resumen-redicta/resumen-redicta.component').then(
            m => m.ResumenRedictaComponent
          ),
      },
      {
        path: 'resumen-sol-larga',
        loadComponent: () =>
          import(
            './feature/resumen-sol-larga/resumen-sol-larga.component'
          ).then(m => m.ResumenSolLargaComponent),
      },
      {
        path: 'capturar-codigo-sol',
        loadComponent: () =>
          import('./feature/codigo-correo/codigo-correo.component').then(
            m => m.CodigoCorreoComponent
          ),
      },
      {
        path: 'incode',
        loadComponent: () =>
          import('./feature/incode/incode.component').then(
            m => m.IncodeComponent
          ),
      },
      {
        path: 'validacion-gobierno-incode',
        loadComponent: () =>
          import(
            './feature/validacion-gobierno-incode/validacion-gobierno-incode.component'
          ).then(m => m.ValidacionGobiernoIncodeComponent),
      },
      {
        path: 'verificar-datos',
        loadComponent: () =>
          import(
            './feature/confirmacion-datos/confirmacion-datos.component'
          ).then(m => m.ConfirmacionDatosComponent),
      },
      {
        path: '**',
        redirectTo: 'not-found',
      },
    ],
  },
  {
    path: 'terminos-condiciones',
    loadComponent: () =>
      import(
        './shared/components/terminos-condiciones/terminos-condiciones.component'
      ).then(m => m.TerminosCondicionesComponent),
  },
  {
    path: 'qr',
    canActivate: [autenticatedGuard],
    loadComponent: () =>
      import('./feature/qr/qr.component').then(m => m.QrComponent),
  },
  {
    path: 'aviso',
    canActivate: [rechazoGuard],
    loadComponent: () =>
      import('./feature/aviso/aviso.component').then(m => m.AvisoComponent),
  },
  {
    path: 'not-found',
    canActivate: [autenticatedGuard],
    loadComponent: () =>
      import('./feature/not-found/not-found.component').then(
        m => m.NotFoundComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./auth/auth.component').then(m => m.AuthComponent),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
